const updatesData = [
  { id: 1, time: '10分钟前', title: '某女星深夜发文暗示遭背叛，三小时后秒删引猜测', tag: '最新' },
  { id: 2, time: '28分钟前', title: '综艺节目录制发生舞台事故，两名工作人员受伤送医', tag: '突發' },
  { id: 3, time: '1小时前', title: '知名导演新片投资方撤资，项目面临停摆危机', tag: '内幕' },
  { id: 4, time: '2小时前', title: '网红直播间意外曝光真实住址，粉丝聚集引发安全隐患', tag: '热议' },
  { id: 5, time: '3小时前', title: '某流量明星代言品牌被曝质量问题，工作室紧急发声明', tag: '追踪' },
  { id: 6, time: '5小时前', title: '音乐颁奖礼提名名单泄露，多位艺人粉丝开启骂战', tag: '独家' },
  { id: 7, time: '7小时前', title: '热门剧集编剧被爆拖欠助理工资，聊天记录全公开', tag: '曝光' },
  { id: 8, time: '9小时前', title: '某男团成员被拍到夜店通宵，经纪公司称正在核实', tag: '吃瓜' },
  { id: 9, time: '12小时前', title: '知名主持人被网友实名举报税务问题，相关部门介入', tag: '重磅' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新爆料
          </h2>
          <p className="mt-2 text-sm text-foreground-500">7x24小时滚动更新，不错过任何一个瓜</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200">
            {updatesData.map((item, idx) => (
              <div
                key={item.id}
                className={`relative pb-8 ${idx === updatesData.length - 1 ? 'pb-0' : ''}`}
              >
                <span className="absolute -left-[25px] top-1 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100"></span>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="text-xs font-medium text-primary-500 bg-primary-50 px-2 py-0.5 rounded whitespace-nowrap w-fit">
                    {item.tag}
                  </span>
                  <p className="text-sm text-foreground-800 leading-relaxed flex-1">{item.title}</p>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}